import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalHeader } from "../ModalHeader";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useEffect, useState } from "react";
import { Alert, Autocomplete, Divider, Grid, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import { ModalFooter } from "../ModalFooter";
import '../../../assets/styles/modals.scss';
import { Loading } from "@/components/common/Loading";
import { Props } from "./ModalBranchOffice.type";
import { branchOfficeService } from "@/service/services/BranchOffice.service";
import { CountryService } from "@/service/services/Country.service";

export const ModalBranchOffice: React.FC<Props> = (props:any): JSX.Element => {

    const { open, closeModal, actionSelected, branchOffice, onListBranchOffices, clearState } = props;

    const [loading, setLoading] = useState<boolean>(false);
    const [branchTypes, setBranchTypes] = useState<any>([]);
    //for get idDistrict
    const [countries, setCountries] = useState<any>([]);
    const [countrySelected, setCountrySelected] = useState<any>('');
    const [departaments, setDepartaments] = useState<any>([]);
    const [departamentSelected, setDepartamentSelected] = useState<any>('');
    const [provinces, setProvinces] = useState<any>([]);
    const [provinceSelected, setProvinceSelected] = useState<any>('');
    const [districts, setDistricts] = useState<any>([]);
    const [districtSelected, setDistrictSelected] = useState<any>('');

    console.log(districtSelected);

    const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
    });

    const [data, setData] = useState({
        id: branchOffice ? branchOffice.id : '',
        code: branchOffice ? branchOffice.code : '',
        address: branchOffice ? branchOffice.address : '',
        phone: branchOffice ? branchOffice.phone : '',
        idofficetype: branchOffice ? branchOffice.idofficetype : '1',
        iddistrict: branchOffice ? branchOffice.iddistrict : '',
    });

    useEffect(() => {
        getBranchTypes();
        getCountries();
    }, []);

    useEffect(() => {
        if(open){
            if(branchOffice){
                setData({
                    id: branchOffice ? branchOffice.id : '',
                    code: branchOffice ? branchOffice.code : '',
                    address: branchOffice ? branchOffice.address : '',
                    phone: branchOffice ? branchOffice.phone : '',
                    idofficetype: branchOffice ? getCustomBranchType(branchOffice.idofficetype, branchTypes) : 1,
                    iddistrict: branchOffice ? branchOffice.iddistrict : '',
                })
            }
        }
    }, [open, branchTypes]);

    //create a find District by id
    // useEffect(() => {
    //     if(branchOffice && districts){
    //         setCustomDistrict(branchOffice.iddistrict, districts);
    //     }
    // }, [branchOffice, districts]);

    const getBranchTypes = async() => {
        setLoading(true);
        await branchOfficeService.getBranchTypes().then((data) => {
            setBranchTypes(data.data || []);
            setLoading(false);
        })
    }

    const getCountries = async () => {
        setLoading(true);
        await CountryService.getCountries().then((data) => {
            setCountries(data.data || [])
           setLoading(false);
        });
    }

    const getDepartments = async (idCountry) => {
        setLoading(true);
        await CountryService.getDepartments(idCountry).then((data) => {
            setDepartaments(data.data || [])
           setLoading(false);
        });
    }

    const getProvinces = async (idDepartament) => {
        setLoading(true);
        await CountryService.getProvinces(idDepartament).then((data) => {
            setProvinces(data.data || [])
           setLoading(false);
        });
    }

    const getDistricts = async (idProvince) => {
        setLoading(true);
        await CountryService.getDistricts(idProvince).then((data) => {
            setDistricts(data.data || [])
           setLoading(false);
        });
    }

    const validateForm = (values) => {
        let errors: any = {};
        if(!values.code) errors.code = "codigo requerido";
        if(!values.address) errors.address = "direccion requerido";
        if(!values.phone) errors.phone = "telefono requerido";
        return errors;
    }

    const onSubmit = async(values, {resetForm})  => {

        if(!districtSelected){
            return (
                setSnackBarConfig(prev => ({ ...prev, open: true, 
                    severity:'warning', 
                    message: `Debe seleccionar un Distrito` }
                ))
            );
        }
        const formData = {
            id: values.id,
            code: values.code,
            address : values.address,
            phone : values.phone,
            idofficetype : values.idofficetype,
            iddistrict : districtSelected?.id,
        }
        setLoading(true);
        if(branchOffice && actionSelected=='edit'){
            await branchOfficeService.editBranch(formData, branchOffice.id).then((data) => {
                onListBranchOffices && onListBranchOffices();
                closeModal && closeModal();
            })
        }else{
            await branchOfficeService.createBranch(formData).then((data) => {
                onListBranchOffices && onListBranchOffices();
                closeModal && closeModal();
            })
        }
        setLoading(false);
    }

    const getCustomBranchType = (oldIdofficetype, branchTypes) => {
        const customRol = branchTypes.find(rol => rol.id == oldIdofficetype);
        return  customRol ? customRol.id : ''
    }

    function setCustomDistrict(idDistrict, districts): any {
        const data = districts && districts.find(charge => charge.id === idDistrict);
        const newData = {
            id: data?.id,
            name: data?.name
        }
        return setDistrictSelected(newData);
    }

    return(
        <>
        {loading && <Loading/>}
        <Snackbar
            open={snackBarConfig.open} 
            autoHideDuration={snackBarConfig.autoHideDuration} 
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
            <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                {snackBarConfig.message || ""}
            </Alert>
        </Snackbar>

        <Modal open={open} handleClose={closeModal} handle size="sm">
            <ModalHeader
                text={(branchOffice && actionSelected=='edit') ? "Editar sucursal" : "Agregar sucursal"}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) =>{
                        return(
                            <form onSubmit={handleSubmit}>
                                <Grid container >
                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>Código:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="code"
                                            variant="standard"
                                            type="text" 
                                            name="code"
                                            fullWidth
                                            value={values.code}
                                            onChange={handleChange}
                                            placeholder="codigo de suscursal"
                                            error={errors.code && touched.code ? true : false}
                                        />
                                        </Grid>
                                    </Grid>

                                    <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                            <Typography variant="body1"><b>Tipo de sucursal:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Select
                                                id="idofficetype"
                                                variant="standard"
                                                value={values.idofficetype}
                                                onChange={(event) => { 
                                                setFieldValue("idofficetype", event.target.value);
                                                }}
                                                error={ errors.idofficetype && touched.idofficetype ? true : false }
                                                fullWidth
                                            >
                                                {
                                                branchTypes.map((bracnhType, i) => {
                                                    // let formatRole = {...bracnhType, name: getCustomBranchType(bracnhType.name)};
                                                    return <MenuItem key={i} value={bracnhType.id}>{bracnhType.name}</MenuItem>;
                                                })
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>

                                    <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                            <Typography variant="body1"><b>Pais:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Select
                                                id="id_nationality"
                                                variant="standard"
                                                value={countrySelected}
                                                onChange={(event) => { 
                                                    setCountrySelected(event.target.value);
                                                }}
                                                fullWidth
                                            >
                                                {
                                                countries.map((country, i) => {
                                                    // var formatRole = {...role, name: getCustomRoleName(role.name)};
                                                    return <MenuItem key={i} value={country.id} onClick={ () => {getDepartments(country.id)}}>{country.name}</MenuItem>;
                                                })
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>

                                    <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                            <Typography variant="body1"><b>Departamento:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Autocomplete
                                                id="disable-portal"
                                                disablePortal
                                                value={departamentSelected}
                                                options={departaments || []}
                                                getOptionLabel={(option) => option.name || ""}
                                                fullWidth
                                                renderInput={(params) => <TextField {...params} variant="standard" label="Escriba para buscar" />}
                                                onChange={(e, newValue) => { 
                                                    setDepartamentSelected(newValue); 
                                                    newValue && getProvinces(newValue?.id);
                                                }}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                            <Typography variant="body1"><b>Provincia:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Autocomplete
                                                id="disable-portal"
                                                disablePortal
                                                value={provinceSelected}
                                                options={provinces || []}
                                                getOptionLabel={(option) => option.name || ""}
                                                fullWidth
                                                renderInput={(params) => <TextField {...params} variant="standard" label="Escriba para buscar" />}
                                                onChange={(e, newValue) => { 
                                                    setProvinceSelected(newValue);
                                                    newValue && getDistricts(newValue?.id); 
                                                }}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                            <Typography variant="body1"><b>Distrito:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Autocomplete
                                                id="disable-portal"
                                                disablePortal
                                                value={districtSelected}
                                                options={districts || []}
                                                getOptionLabel={(option) => option.name || ""}
                                                fullWidth
                                                renderInput={(params) => <TextField {...params} variant="standard" label="Escriba para buscar" />}
                                                onChange={(e, newValue) => { setDistrictSelected(newValue) }}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px' >
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>Dirección:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="address"
                                            variant="standard"
                                            type="text" 
                                            name="address"
                                            multiline
                                            maxRows={4}
                                            fullWidth
                                            value={values.address}
                                            onChange={handleChange}
                                            placeholder="direccion"
                                            error={errors.address && touched.address ? true : false}
                                        />
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px' >
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>Télefono:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="phone"
                                            variant="standard"
                                            type="text" 
                                            name="phone"
                                            multiline
                                            maxRows={4}
                                            fullWidth
                                            value={values.phone}
                                            onChange={handleChange}
                                            placeholder="telefono"
                                            error={errors.phone && touched.phone ? true : false}
                                        />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={(branchOffice && actionSelected=='edit') ? "ACTUALIZAR" : "REGISTRAR"}
                                    cancelText="CANCELAR" 
                                    onCancel={closeModal}
                                    onConfirm={handleSubmit}
                                    clearState={clearState}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </ModalBody>
        </Modal>
        </>
    );
}